import { toReadableDateString } from '../robowhale/utils/date/readable-date-string'
import { merge } from 'es-toolkit/compat'
import { IGameConfig } from './../IGameConfig'
import { detectEnv, Env } from './Env'
import { detectPlatform, Platform } from './Platform'

export function initGameConfig() {
	const env = detectEnv()
	const envConfig = getEnvConfig(env)
	if (!envConfig) {
		throw new Error(`Config not found for '${Env[env]}' env`)
	}

	const platform = detectPlatform()
	const platformConfig = getPlatformConfig(platform)
	if (!platformConfig) {
		throw new Error(`Config not found for '${platform}' platform`)
	}

	const defaultConfig = window.configs._default

	const config = merge({}, defaultConfig, envConfig, platformConfig) as IGameConfig
	config.env = env
	config.platform = platform

	// @ts-expect-error
	if (config.build_type === '{{ BUILD_TYPE }}') {
		config.build_type = 'dev'
	}

	// @ts-expect-error
	if (config.build_time === '{{ BUILD_TIME }}') {
		config.build_time = Date.now()
	}

	if (typeof config.build_time === 'string') {
		config.build_time = parseInt(config.build_time)
	}

	// @ts-expect-error
	if (config.build_version === '{{ BUILD_VERSION }}') {
		config.build_version = 1
	}

	if (typeof config.build_version === 'string') {
		config.build_version = parseInt(config.build_version)
	}

	window.game.config = config
	console.info(`Config`, config)
	console.info('Build #' + config.build_version, toReadableDateString(config.build_time))
	console.info('Env:', env)
	console.info('Platform:', platform)
}

function getEnvConfig(env: Env) {
	return window.configs.env[env]
}

function getPlatformConfig(platform: Platform) {
	return window.configs.platform[platform]
}
